import axios from "axios";

export const getTournament = async (tournamentId, token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_USER}/getTournament/${tournamentId}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
